import React from 'react'
import { createContext, useEffect, useState, useContext, useRef, useCallback, useMemo } from 'react';
import { UCMSContext } from './UCMSContext';
import api from '../services/api';
const InfosContext = createContext();

function InfosProvider({ children }) {

  const [loading, setLoading] = useState(0)
  const [loadAgentsStats, setLoadAgentsStats] = useState(0)
  const [loadAgentsDetails, setLoadAgentsDetails] = useState(0)
  const [queueStats, setQueueStats] = useState([]);
  const [agentsDetails, setAgentsDetails] = useState([]);
  const [agentsStats, setAgentsStats] = useState([]);
  const [periodo, setPeriodo] = useState({
    start: '',
    end: ''
  });
  const ucmsContext = useContext(UCMSContext);
  const [search, setSearch] = useState('');
  const fetchingRef = useRef(false);

  function parsePercent(value, total) {
    return Math.round((value / total) * 100)
  }

  // Build date params for server-side filtering
  function getDateParams() {
    if (periodo.start && periodo.end) {
      return { startDate: periodo.start, endDate: periodo.end }
    }
    return {}
  }

  async function getQueuesStats(idUCM) {
    setLoading(1)
    const dateParams = getDateParams()
    const newStats = []
    for (let i = 0; i < ucmsContext.ucmSelected.queues?.length; i++) {
      if (ucmsContext.ucmSelected._id !== idUCM || fetchingRef.current === false) return;
      setLoading(parsePercent(i, ucmsContext.ucmSelected.queues?.length))
      let queue = ucmsContext.ucmSelected.queues[i];
      let resp = await api.post("/queues/stats", {
        ucm: ucmsContext.ucmSelected._id,
        queue: queue.extension,
        ...dateParams
      }).catch(err => console.error(err))
      if (resp?.data) {
        newStats.push(resp.data)
      }
    }
    setQueueStats(newStats);
    setLoading(100)
  }

  async function getAgentsDetails(idUCM) {
    setLoadAgentsDetails(1)
    const dateParams = getDateParams()
    let detailsArray = [];
    for (let i = 0; i < ucmsContext.ucmSelected.queues?.length; i++) {
      if (ucmsContext.ucmSelected._id !== idUCM || fetchingRef.current === false) return;
      let queue = ucmsContext.ucmSelected.queues[i];
      let members = queue.members;
      if (members) {
        members = members.split(',');
        for (let j = 0; j < members.length; j++) {
          setLoadAgentsDetails(parsePercent(i, ucmsContext.ucmSelected.queues?.length))
          let response = await api.post("/agents/details", {
            ucm: ucmsContext.ucmSelected._id,
            queue: queue.extension,
            members: members,
            ...dateParams
          }).catch(err => console.error(err))
          let stats = response?.data;
          if (stats && !stats.error) {
            detailsArray.push(stats);
          }
        }
      }
    }
    setAgentsDetails(detailsArray);
    setLoadAgentsDetails(100)
  }

  async function getAgentsStats(idUCM) {
    setLoadAgentsStats(1)
    const dateParams = getDateParams()
    let statArray = [];
    for (let i = 0; i < ucmsContext.ucmSelected.queues?.length; i++) {
      if (ucmsContext.ucmSelected._id !== idUCM || fetchingRef.current === false) return
      let queue = ucmsContext.ucmSelected.queues[i];
      let members = queue.members;
      if (members) {
        members = members.split(',');
        for (let j = 0; j < members.length; j++) {
          setLoadAgentsStats(parsePercent(i, ucmsContext.ucmSelected.queues?.length))
          let response = await api.post("/agents/stats", {
            ucm: ucmsContext.ucmSelected._id,
            queue: queue.extension,
            members: members,
            ...dateParams
          }).catch(err => console.error(err))
          let stats = response?.data;
          if (stats && !stats.error) {
            statArray.push(stats)
          }
        }
      }
    }
    setAgentsStats(statArray);
    setLoadAgentsStats(100)
  }

  const fetchAllData = useCallback(function() {
    if (!ucmsContext.ucmSelected) return
    fetchingRef.current = true
    cleanDataAndReqs();
    const id = ucmsContext.ucmSelected._id.toString()
    getQueuesStats(id);
    getAgentsStats(id);
    getAgentsDetails(id);
  }, [ucmsContext.ucmSelected])

  // Fetch when UCM changes
  useEffect(() => {
    if (ucmsContext.ucmSelected) {
      fetchAllData()
    }
    return () => { fetchingRef.current = false }
  }, [ucmsContext.ucmSelected])

  // Re-fetch when date range changes (server-side filtering)
  useEffect(() => {
    if (ucmsContext.ucmSelected && periodo.start && periodo.end) {
      fetchAllData()
    }
    return () => { fetchingRef.current = false }
  }, [periodo.start, periodo.end])

  function cleanDataAndReqs() {
    setQueueStats([]);
    setAgentsDetails([]);
    setAgentsStats([]);
  }

  const value = useMemo(() => ({
    queueStats, loading, agentsDetails, agentsStats, periodo, setPeriodo, loadAgentsStats, loadAgentsDetails, search, setSearch, fetchAllData
  }), [queueStats, loading, agentsDetails, agentsStats, periodo, loadAgentsStats, loadAgentsDetails, search, fetchAllData])

  return (
    <InfosContext.Provider value={value}>
      {children}
    </InfosContext.Provider>
  )
}

export { InfosContext, InfosProvider }
